import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { CgEye } from "react-icons/cg";
import BrandDetailsDialog from "./brand details dialog/BrandDetailsDialog";
import { useNavigate } from "react-router-dom";
import pages from "../../../constants/pages";

export default function RelatedBrandList({ formData, brands }) {
  const navigate = useNavigate();
  const [brandData, setBrandData] = useState({
    data: {},
    state: false,
  });

  return (
    <Fragment>
      {brands.map((brand) => (
        <Grid size={6}>
          <div className="agencies-brand-div">
            <Typography className="brand-name-agency">
              {brand.brandName}
            </Typography>

            <Tooltip title="View Brand Details">
              <IconButton
                onClick={() =>
                  navigate(
                    pages.unverifiedPageDetails.route + "?brandID=" + brand.ID,
                    {
                      state: {
                        showAudience: true,
                        showCampaignButton: true,
                        component: "platform",
                      },
                    }
                  )
                }
              >
                <CgEye className="eye-icon" />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
      ))}

      <BrandDetailsDialog details={brandData} setDetails={setBrandData} />
    </Fragment>
  );
}
